<template>
  <FocusTrap>
    <div  id="mycard" class="card">

    <div class="card-header" style="padding: 0px">
      <div class="page-header page-header-light" >
        <div class="page-header-content header-elements-lg-inline" >
          <div class="page-title d-flex" style="padding: 0px;">
            <h6>
              <i class="icon-list mr-2"></i> <span class="font-weight-semibold">Sale </span> - List
            </h6>
            <a href="#" class="header-elements-toggle text-body d-lg-none"><i class="icon-more"></i></a>
          </div>

          <div class="header-elements d-none">
            <form action="#">
              <div class="form-group">

                <div class="input-group input-group-feedback input-group-feedback-right wmin-lg-200">
                  <input id="txtsearch" type="text" class="form-control wmin-lg-200" placeholder="Search" autocomplete="off" style="padding-left: 20px;">
                  <div class="form-control-feedback">
                    <i class="icon-search4"></i>
                  </div>

                  <div class="input-group-append position-static">
                    <button type="button" class="btn btn-outline-secondary btn-icon" @click="showFilterWindow">
                      <i class="icon-gear"></i>
                    </button>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>


    <div class="table-responsive">
      <table id="invoice_list_table"
             class="table  table-hover  table-bordered table-condensed table-columned"
             data-search="false"
             data-show-refresh="false"
             data-show-columns="false"
             data-pagination="false"
             data-page-list="[10, 25, 50, 100, ALL]"
             data-show-footer="false"
             data-toggle="context"
             data-row-style="rowStyle"
             data-target=".context-table">
        <thead>
        <tr>
          <th data-field="id" data-class="d-none">id</th>
          <th data-field="status" data-class="d-none">Status</th>
          <th data-formatter="runningFormatter" data-width="75" >S.No</th>
          <th data-field="doc_date" data-width="110" data-formatter="dateFormatter" data-sortable="true">Date</th>
          <th data-field="doc_no" data-width="100" data-sortable="true">Inv No</th>
          <th data-field="type" data-width="100" data-formatter="transactionTypeFormatter" data-sortable="true">Type</th>
          <th data-field="buyer.name" data-sortable="true">Party</th>
          <!--<th data-field="ref_no" data-width="100" data-sortable="true">Inv No</th>-->
          <!--<th data-field="ref_date" data-width="110" data-formatter="dateFormatter" data-sortable="true">Inv Date</th>-->

          <th data-field="gross_amt" data-width="100" data-align="right" data-formatter="indianFormat" data-sortable="true">Taxable</th>
          <th data-field="tax_amt" data-width="100" data-align="right" data-formatter="indianFormat" data-sortable="true">Tax</th>
          <th data-field="net_amt" data-width="100" data-align="right" data-formatter="indianFormat" data-sortable="true">Amount</th>
          <th data-field="remarks" data-sortable="true">Remarks</th>
        </tr>
        </thead>
        <tbody>

        </tbody>
        <tfoot>
        </tfoot>
      </table>
    </div>

    <!-- Context Menu -->
    <div id="context-menu" class="context-table" z-index="99999">
      <div class="dropdown-menu">

        <a href="#" class="dropdown-item" @click="loadData"><i class="icon-reset" style="color: darkgreen"></i>Refresh</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"><i class="icon-printer" ></i>Print Preview 1</a>
        <a href="#" class="dropdown-item"><i class="icon-printer" ></i>Print Preview 2</a>
        <a href="#" class="dropdown-item"><i class="icon-printer" ></i>Print Preview 4</a>
        <a href="#" class="dropdown-item"><i class="icon-printer" ></i>Print Preview 4.1</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" ><i class="icon-compass4" style="color: darkgreen"></i>Generate IRN</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" > <i class="icon-truck" ></i>Update LR & Date</a>
        <a href="#" class="dropdown-item" > <i class="icon-map5" ></i>Update Export Info</a>
        <a href="#" class="dropdown-item" style="color: firebrick;"> <i class="icon-balance" ></i>Change Unit</a>
        <a href="#" class="dropdown-item" style="color: blue;"> <i class="icon-pencil3" ></i>Modify Invoice</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" style="color: red" @click="removeDocument"> <i class="icon-blocked" ></i>Cancel</a>
      </div>
    </div>
    <!-- End of Context Menu -->


    <vmodal name="invoice_window" transition="nice-modal-fade" :delay="100" :resizable="true" width="90%" height="80%" @closed="afterClose" >
      <SaleInvoiceForm v-if="invoice.id > 1" v-bind:myvoucher="invoice" v-on:sale_invoice_saved="loadData" v-on:saleinvoice_window_closed="closeInvoiceWindow" />
    </vmodal>


    <!-- The Modal -->
    <div class="modal" id="invoiceModal" >
      <div class="modal-dialog  modal-full modal-dialog-centered modal-dialog-scrollable" >
        <div class="modal-content" >

          <!-- Modal body -->
          <div class="modal-body" >
            <SaleInvoiceForm v-if="invoice.id > 1" v-bind:myvoucher="invoice" v-on:sale_invoice_saved="loadData" v-on:saleinvoice_window_closed="closeInvoiceWindow" ></SaleInvoiceForm>
          </div>


        </div>
      </div>
    </div>
    <!--/The Modal -->

    <!--    LR No Update  -->
      <vmodal name="lr_window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="600" height="250" >
        <form>
          <div class="card">
            <div class="card-header header-elements-inline bg-primary" style="padding: 10px;">
              <h3 class="card-title">LR No & Date Update</h3>
              <div class="header-elements">
                <div class="list-icons">
                  <!--<a class="list-icons-item" data-action="remove" @click="closeRequest"></a>-->
                </div>
              </div>
            </div>

            <div class="card-body">

              <p/>

              <div class="form-group row">
                <label class="col-md-3 col-form-label">LR Date:</label>
                <div class="col-md-9">
                  <input id= "txtLR" type="date" class="form-control"  v-model="lr_date" />
                </div>
              </div>


              <div class="form-group row">
                <label class="col-md-3 col-form-label">LR No:</label>
                <div class="col-md-9">
                  <input class="form-control" maxlength="15"  v-model="lr_no" />
                </div>
              </div>


              <div class="text-right">
                <SaveButton @handle_save_action="update_lr_no" >Update</SaveButton>
              </div>

            </div>
          </div>
        </form>
      </vmodal>
    <!--    /LR No Update  -->

    <!--export_window -->
      <vmodal name="export_window" transition="nice-modal-fade" :delay="100" :resizable="true" width="80%" height="auto" style="padding: 0px;"  @closed="afterExportWindowClosed" @opened="beforeExportWindowOpened"  >
        <form>
          <div class="card">
            <div class="card-header header-elements-inline bg-primary" style="padding: 10px;">
              <h3 class="card-title">Export Information Update</h3>
              <div class="header-elements">
                <div class="list-icons">
                  <!--<a class="list-icons-item" data-action="remove" @click="closeRequest"></a>-->
                </div>
              </div>
            </div>

            <div class="card-body">

              <p/>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">Dispatch No:</label>
                <div class="col-md-4">
                  <input class="form-control" maxlength="15"  v-model="export_info.dispatch_no" />
                </div>

                <label class="col-md-2 col-form-label">Date:</label>
                <div class="col-md-2">
                  <input type="date" class="form-control"  v-model="export_info.dispatch_date" />
                </div>

<!--                <label class="col-md-1 col-form-label">Conv Rate:</label>-->
<!--                <div class="col-md-2">-->
<!--                  <input type="number" class="form-control"  v-model="export_info.conv_rate" />-->
<!--                </div>-->

              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">Dispatch Through:</label>
                <div class="col-md-4">
                  <input class="form-control" maxlength="15"  v-model="export_info.dispatch_through" />
                </div>

                <label class="col-md-2 col-form-label">Destination:</label>
                <div class="col-md-4">
                  <input type="text" class="form-control"  maxlength="25" v-model="export_info.destination" />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">Vessel/Flight No:</label>
                <div class="col-md-4">
                  <input class="form-control" maxlength="15"  v-model="export_info.vessel_no" />
                </div>

                <label class="col-md-2 col-form-label">Place of Receipt by Shipper:</label>
                <div class="col-md-4">
                  <input type="text" class="form-control"  maxlength="25" v-model="export_info.place_of_receipt" />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">City/Port of Loading:</label>
                <div class="col-md-4">
                  <input class="form-control" maxlength="15"  v-model="export_info.port_of_loading" />
                </div>

                <label class="col-md-2 col-form-label">City/Port of Discharge:</label>
                <div class="col-md-4">
                  <input type="text" class="form-control"  maxlength="25" v-model="export_info.port_of_discharge" />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">LUT/Bond No:</label>
                <div class="col-md-4">
                  <input class="form-control" maxlength="15"  v-model="export_info.bond_no" />
                </div>

                <label class="col-md-1 col-form-label">From:</label>
                <div class="col-md-2">
                  <input type="date" class="form-control"  maxlength="25" v-model="export_info.bond_from" />
                </div>

                <label class="col-md-1 col-form-label">To:</label>
                <div class="col-md-2">
                  <input type="date" class="form-control"  maxlength="25" v-model="export_info.bond_upto" />
                </div>

              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">FOB $:</label>
                <div class="col-md-4">
                  <input class="form-control" type="number"  step="any" v-model="export_info.fob" />
                </div>

                <label class="col-md-1 col-form-label">Freight:</label>
                <div class="col-md-2">
                  <input type="number" class="form-control"  v-model="export_info.freight" />
                </div>

                <label class="col-md-1 col-form-label">Insurance:</label>
                <div class="col-md-2">
                  <input type="number" class="form-control" v-model="export_info.insurance" />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">Terms of Delivery:</label>
                <div class="col-md-10">
                  <textarea class="form-control" rows="2" v-model="export_info.terms_of_delivery"/>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">Invoice Type:</label>
                <div class="col-md-1">
                  <select class="form-control" v-model="export_info.is_fob">
                    <option value="1">C I F</option>
                    <option value="0">F O B</option>
                  </select>
                </div>

                <label class="col-md-1 col-form-label">E Way Bill No:</label>
                <div class="col-md-2">
                  <input class="form-control" type="text"  maxlength="25" v-model="export_info.eway_no" />
                </div>

                <label class="col-md-1 col-form-label">Country:</label>
                <select class="form-control col-md-2" v-model="export_info.country">
                  <option value="">-- Select Country --</option>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                  <option value="Botswana">Botswana</option>
                  <option value="Brazil">Brazil</option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cabo Verde">Cabo Verde</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Central African Republic">Central African Republic</option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo (Congo-Brazzaville)">Congo (Congo-Brazzaville)</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Democratic Republic of the Congo">Democratic Republic of the Congo</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Eswatini">Eswatini</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Greece">Greece</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran">Iran</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Laos">Laos</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libya">Libya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia">Micronesia</option>
                  <option value="Moldova">Moldova</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="North Korea">North Korea</option>
                  <option value="North Macedonia">North Macedonia</option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Palestine State">Palestine State</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Romania">Romania</option>
                  <option value="Russia">Russia</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                  <option value="Saint Lucia">Saint Lucia</option>
                  <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Korea">South Korea</option>
                  <option value="South Sudan">South Sudan</option>
                  <option value="Spain">Spain</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syria">Syria</option>
                  <option value="Taiwan">Taiwan</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Timor-Leste">Timor-Leste</option>
                  <option value="Togo">Togo</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Emirates">United Arab Emirates</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="United States">United States</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vatican City">Vatican City</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>

                <label class="col-md-1 col-form-label">PI No:</label>
                <div class="col-md-2">
                  <input class="form-control" type="text"  maxlength="25" v-model="export_info.pi_no" />
                </div>

              </div>


              <div class="text-right">
                <SaveButton @handle_save_action="update_export_info" >Update</SaveButton>
              </div>

            </div>
          </div>
        </form>
      </vmodal>
    <!--/export_window -->

    <vmodal name="filter_window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="600" height="300" @opened="afterfilterwindow_visible">
      <form>
        <div class="card">
          <div class="card-header header-elements-inline bg-primary" style="padding: 10px;">
            <h3 class="card-title">Filter</h3>
            <div class="header-elements">
              <div class="list-icons">
                <!--<a class="list-icons-item" data-action="remove" @click="closeRequest"></a>-->
              </div>
            </div>
          </div>

          <div class="card-body">

            <p/>

            <div class="form-group row">
              <label class="col-md-3 col-form-label">From:</label>
              <div class="col-md-3">
                <input id= "txtfrom" type="date" class="form-control"  v-model="from_date" :max="upto_date" />
              </div>

              <label class="col-md-3 col-form-label">Upto</label>
              <div class="col-md-3">
                <input type="date" class="form-control"  v-model="upto_date" :min="from_date" />
              </div>
            </div>


            <div class="form-group row">
              <label class="col-md-3 col-form-label">Sale Type:</label>
              <div class="col-md-9">
                <select id="cmbtypes" class="form-control" v-model="saletype" >
                  <option value="0" selected>All</option>
                  <option value="404">B2B-Local</option>
                  <option value="405">B2C-Local</option>
                  <option value="406">Export</option>
                  <option value="407">B2B-Others</option>
                  <option value="408">B2C-Others</option>
                  <option value="409">Exempted</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 col-form-label">Buyer:</label>
              <div class="col-md-9">
                <select class="form-control" required="" v-model="buyer_id" >
                  <option value="0" selected>All</option>
                  <option v-for="buyer in buyers" v-bind:value="buyer.id">
                    {{ buyer.name }}
                  </option>
                </select>
              </div>
            </div>


            <div class="text-right">
              <button type="button" class="btn btn-outline alpha-success text-success-800 border-success-600 legitRipple" @click="loadData" >Show Data<i class="icon-database-refresh ml-2"></i></button>
            </div>

          </div>
        </div>
      </form>
    </vmodal>

    <!-- modal -->
    <div id="fsPrintPreview"
         class="modal animated bounceIn"
         tabindex="-1"
         role="dialog"
         aria-labelledby="myModalLabel"
         aria-hidden="true">

        <!-- dialog -->
        <div class="modal-dialog modal-full">

          <!-- content -->
          <div class="modal-content" style="padding: 0px;">

            <!-- body -->
            <div class="modal-body">
              <ReportViewer v-if="can_print" v-bind:reportfilename="filename" v-bind:json_data=invoice v-bind:report_url="reppath"></ReportViewer>
            </div>
            <!-- body -->

          </div>
          <!-- content -->

        </div>
        <!-- dialog -->

    </div>
    <!-- modal -->

  </div>
  </FocusTrap>
</template>

<script>
  import SaleInvoiceForm from './SaleInvoiceForm';
  import FabButton from '@/components/core/FabButton.vue'
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  import { store } from '@/store/store.js'
  import ReportViewer from "@/views/tools/ReportViewerByJson";
  import SaveButton from '../../../../components/core/buttons/SaveButton.vue'

  export default {
    name: 'SaleInvoiceView',
    components: {
      SaveButton,
      ReportViewer,
      SaleInvoiceForm,
      FabButton
    },
    store,
    data () {
      return {
        mytable: {},
        invoice: JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}'),
        export_info: {"id":0,"is_fob": 0,"currency":"$","dispatch_no":"","dispatch_date":"","dispatch_through":"","destination":"","vessel_no":"","place_of_receipt":"","port_of_loading":"","port_of_discharge":"","country":"","bond_no":"","bond_from":"","bond_upto":"","terms_of_delivery":"","fob":0,"freight":0,"insurance":0,"pi_no":"","conv_rate":0},
        series: 404,
        saletype: 0,
        buyer_id: 0,
        from_date: moment().add(-7, 'days').format('YYYY-MM-DD'),
        upto_date: moment().format('YYYY-MM-DD'),
        can_print: false,
        isActive: false,
        lr_no: '',
        lr_date:'2000-01-01',
        buyers : [],
        filename: 'invoice.mrt',
        reppath: '',
        invoice_id : 0,
      }
    },
    created () {

    },
    mounted () {
      const self = this;

      self.export_info.dispatch_date = moment().format('YYYY-MM-DD');
      self.export_info.bond_from = moment().format('YYYY-MM-DD');
      self.export_info.bond_upto = moment().format('YYYY-MM-DD');

      this.$data.mytable = $('#invoice_list_table');
      this.$data.mytable.bootstrapTable();
      $('#invoice_list_table').on('post-body.bs.table', function (e) {
        $('[data-toggle="popover"]').popover();
      });

      this.$data.mytable.contextmenu({
        target: '#context-menu',
        scopes: 'tbody > tr',
        onItem: function (row, e) {


          let id = $(row.children('*')[0]).text();
          let status =  $(row.children('*')[1]).text();
          self.$data.invoice_id = id;

          if ($(e.target).text() === 'Modify Invoice') {
              self.modifyDocument(id);
          }else if ($(e.target).text() == 'Change Unit'){
            self.change_unit(id);
          }else if ($(e.target).text() == 'Print Preview 1'){
            self.printPreview(id);
          }else if ($(e.target).text() == 'Print Preview 2'){
            self.printPreview2(id);
          }else if ($(e.target).text() == 'Print Preview 4'){
            self.printPreview4(id);
          }else if ($(e.target).text() == 'Print Preview 4.1'){
            self.printPreview4_1(id);
          }else if ($(e.target).text() == 'Update Export Info'){
            self.showExportWindow(id);
          }else if ($(e.target).text() == 'Update LR & Date'){
            self.showLRWindow(id);
          }else if ($(e.target).text() === 'Cancel') {
             if(status === 'Active') {
              self.removeDocument(id);
             }
          }else if ($(e.target).text() == 'Preview'){
            self.invoicePreview(id);
          }else if( $(e.target).text() === 'Generate IRN') {
            self.generate_irn(id);
          }
        }
      });

      $('#txtsearch').keyup(function () {
        var val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase();
        $('#invoice_list_table>tbody>tr').show().filter(function () {
          var text = $(this).text().replace(/\s+/g, ' ').toLowerCase();
          return !~text.indexOf(val);
        }).hide();
      });

      self.loadBuyers();
      self.$data.from_date = moment().add(-7,'d').format('YYYY-MM-DD');

      self.isActive = false;
      self.$modal.show('filter_window');

      $('#fsPrintPreview').on('hidden.bs.modal', function (e) {
        self.isActive = false;
        self.reppath = '';
      });

    },
    methods: {
      afterfilterwindow_visible(){
        $('#txtfrom').focus();
      },
      showFilterWindow(){
        this.$modal.show('filter_window');
      },
      closeModal() {
        this.$modal.hide('invoice_window');
        $('#previewmodal').modal('hide');
      },
      beforeOpen(){

      },
      afterClose(){
        this.$data.invoice = JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}');
        // this.$data.invoice = JSON.parse('{"id":0,"ver":0,"status":0,"is_cr":"N","type":0,"finyear":2018,"series":302,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","ledger":{"id":0,"type":0,"group_code":0,"name":"","print_name":"","street":"","city":"","pin":"","state_id":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","vehicle_no":"","process":{"id":0,"name":"","nature":0,"p_name":"","sys_obj":false},"remarks":"","gross_amount":0,"tax_amount":0,"round_off":0,"net_amount":0,"list":[]}');
      },
      showModal () {
        //this.$modal.show('invoice_window');
        $('#invoiceModal').modal('show');
      },
      async getExportInfo(){
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        console.log(`${process.env.VUE_APP_ROOT_API}api/saleinvoice_export_info/${self.invoice_id}`);
        fetch(`${process.env.VUE_APP_ROOT_API}api/saleinvoice_export_info/${self.invoice_id}`,requestOptions).then(userService.handleResponse).then((resp) => {
          if(resp.ok) {
            console.log(JSON.stringify(resp.data));
            self.$data.export_info = resp.data;
            // self.$data.export_info.dispatch_date = moment(resp.data.dispatch_date).format('YYYY-MM-DD');
            // self.$data.export_info.bond_from = moment(resp.data.bond_from).format('YYYY-MM-DD');
            // self.$data.export_info.bond_upto = moment(resp.data.bond_upto).format('YYYY-MM-DD');
            $('#export_window').modal('show');
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }

        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        });
      },
      async beforeExportWindowOpened () {
        this.export_info = {
          "id": 0,
          "is_fob": 0,
          "currency": "$",
          "dispatch_no": "",
          "dispatch_date": "",
          "dispatch_through": "",
          "destination": "",
          "vessel_no": "",
          "place_of_receipt": "",
          "port_of_loading": "",
          "port_of_discharge": "",
          "country": "",
          "bond_no": "",
          "bond_from": "",
          "bond_upto": "",
          "terms_of_delivery": "",
          "fob": 0,
          "freight": 0,
          "insurance": 0,
          "conv_rate": 0,
        };
        this.export_info.dispatch_date = moment().format('YYYY-MM-DD');
        this.export_info.bond_from = moment().format('YYYY-MM-DD');
        this.export_info.bond_upto = moment().format('YYYY-MM-DD');
        // await this.getExportInfo();
      },
      afterExportWindowClosed(){
        this.export_info = {"id":0,"is_fob": 0,"currency":"$","dispatch_no":"","dispatch_date":"","dispatch_through":"","destination":"","vessel_no":"","place_of_receipt":"","port_of_loading":"","port_of_discharge":"","country":"","bond_no":"","bond_from":"","bond_upto":"","terms_of_delivery":"","fob":0,"freight":0,"insurance":0,"pi_no":"", "conv_rate":0};
      },
      closeInvoiceWindow(){
        this.$modal.hide('invoice_window');
        $('#invoiceModal').modal('hide');
      },
      blockModal(){
        $('#mycard').block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });
      },
      invoicePreview(id){
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode: "cors",
          headers: userService.authHeader()
        };

        self.$data.invoice = {};

        fetch(`${process.env.VUE_APP_ROOT_API}api/sale/${id}`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok) {

            self.$data.invoice = resp.data;
            self.$data.invoice.doc_date = moment(resp.data.doc_date).format('YYYY-MM-DD');
            self.$data.invoice.ref_date = moment(resp.data.ref_date).format('YYYY-MM-DD');
            $('#previewmodal').modal('show');

          } else {
            swal({ title: "Oops!", text: resp.msg, type: "error" });
          }
        }).catch(function (err) {
          swal({ title: "Oh noes!", text: err.toString(), type: "error" });
        });

      },
      modifyDocument (id) {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.mytable.bootstrapTable('showLoading');

        // alert(`${process.env.VUE_APP_ROOT_API}api/sale/${id}`);
        self.$data.invoice = JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}');
        fetch(`${process.env.VUE_APP_ROOT_API}api/sale/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {

            self.$data.invoice = resp.data;
            self.$data.invoice.doc_date = moment(resp.data.doc_date).format('YYYY-MM-DD');
            self.$data.invoice.ref_date = moment(resp.data.ref_date).format('YYYY-MM-DD');


            $('#invoiceModal').modal('show');

          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }

        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(()=>{
          self.$data.mytable.bootstrapTable('hideLoading');
        });
      },
      removeDocument (id) {
        const self = this;

        self.$data.invoice.id = id;

        const requestOptions = {
          method: 'DELETE',
          mode:'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.invoice)
        };

        swal({
          title: 'What is the reason for cancel this transaction?',
          input: 'text',
          inputPlaceholder: 'Enter Remarks here',
          showCancelButton: true,
          inputClass: 'form-control',
          inputValidator: function(value) {
            return !value && 'You need to write something!'
          }
        }).then(function(result) {
          if(result.value) {
            fetch(`${process.env.VUE_APP_ROOT_API}api/sale?remarks=${result.value}`,requestOptions).then(userService.handleResponse).then(function (resp) {
              self.$modal.hide('receipt-window');
              if(resp.ok){
                self.loadData();
                swal({
                  title: 'Canceled!',
                  text: 'Your request has been processed',
                  type: 'success'
                });
              }else {
                swal({ title: "Oops", text: resp.msg, type: "info" });
              }

            }).catch(function (err) {
              swal({ title: "Oops", text: err.toString(), type: "error" });
            });
          }
        });


      },
      loadData () {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        $('#txtsearch').val('');

        self.$modal.hide('filter_window');
        self.$modal.hide('invoice_window');
        $('#previewmodal').modal('hide');
        $('#invoice_window').modal('hide');

        $(self.$data.mytable).block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        self.$data.mytable.bootstrapTable('load',[]);
        self.$data.mytable.bootstrapTable('showLoading');

        fetch(`${process.env.VUE_APP_ROOT_API}api/sales?cmp_id=${self.$store.state.user.company.id}&buyer_id=${self.$data.buyer_id}&from=${self.$data.from_date}&upto=${self.$data.upto_date}&type=${self.$data.saletype}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            if( Array.isArray(resp.data)){
              self.$data.mytable.bootstrapTable('load', resp.data);
            }
            self.$modal.hide('filter_window');
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(function () {
          self.$data.mytable.bootstrapTable('hideLoading');
          $(self.$data.mytable).unblock();
        });

      },
      loadBuyers () {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        this.$modal.hide('buyer_window');

        this.$data.buyers = [];
        fetch(`${process.env.VUE_APP_ROOT_API}api/buyers`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            if( _.isArray(resp.data)){
              self.$data.buyers = resp.data;
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        });

      },
      printPreview(id){
        const self = this;

        self.$data.reppath =  '';

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        // alert(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}`);
        self.$data.mytable.bootstrapTable('showLoading');
        self.$data.can_print = false;
        self.$data.invoice = JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}');
        fetch(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok) {

            if (!_.isNull(resp.data)) {

              self.$data.filename = 'invoice_1.mrt';
              self.$data.invoice = resp;
              self.$data.invoice.data.doc_date = moment(resp.data.doc_date).format('YYYY-MM-DD');
              self.$data.invoice.data.ref_date = moment(resp.data.ref_date).format('YYYY-MM-DD');
              self.$data.reppath =  `${process.env.VUE_APP_ROOT_API}api/sale/${id}`;
              self.$data.can_print = true;

              $('#fsPrintPreview').modal('show');

            }
          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' })
          }

        }).catch(function (err) {
          swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
        }).finally(()=>{
          self.$data.mytable.bootstrapTable('hideLoading');
        });


      },
      printPreview2(id){
        const self = this;

        self.$data.reppath =  '';

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        // alert(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}`);

        self.$data.mytable.bootstrapTable('showLoading');
        self.$data.can_print = false;
        self.$data.invoice = JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}');
        fetch(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok) {
            if (!_.isNull(resp.data)) {

              self.$data.filename = 'invoice_2.mrt';
              self.$data.invoice = resp;
              self.$data.invoice.data.doc_date = moment(resp.data.doc_date).format('YYYY-MM-DD');
              self.$data.invoice.data.ref_date = moment(resp.data.ref_date).format('YYYY-MM-DD');
              self.$data.reppath =  `${process.env.VUE_APP_ROOT_API}api/sale/${id}`;
              self.$data.can_print = true;

              $('#fsPrintPreview').modal('show');
              // setTimeout(function (){
              //   $('#fsPrintPreview').modal('hide');
              // }, 1000);

            }
          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' })
          }

        }).catch(function (err) {
          swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
        }).finally(()=>{
          self.$data.mytable.bootstrapTable('hideLoading');
        });
      },
      printPreview4(id){
        const self = this;

        self.$data.reppath =  '';

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        // alert(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}`);

        self.$data.mytable.bootstrapTable('showLoading');
        self.$data.can_print = false;
        self.$data.invoice = JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}');

        console.log(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}?export_info=true&currency=USD`)

        fetch(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}?export_info=true&currency=USD`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok) {
            if (!_.isNull(resp.data)) {

              console.log(JSON.stringify(resp));

              self.$data.filename = 'invoice_4.mrt';
              self.$data.invoice = resp;
              self.$data.invoice.data.doc_date = moment(resp.data.doc_date).format('YYYY-MM-DD');
              self.$data.invoice.data.ref_date = moment(resp.data.ref_date).format('YYYY-MM-DD');
              self.$data.reppath =  `${process.env.VUE_APP_ROOT_API}api/sale/${id}`;
              self.$data.can_print = true;

              $('#fsPrintPreview').modal('show');
              // setTimeout(function (){
              //   $('#fsPrintPreview').modal('hide');
              // }, 1000);

            }
          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' })
          }

        }).catch(function (err) {
          swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
        }).finally(()=>{
          self.$data.mytable.bootstrapTable('hideLoading');
        });
      },
      printPreview4_1(id){
        const self = this;

        self.$data.reppath =  '';

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        self.$data.mytable.bootstrapTable('showLoading');
        self.$data.can_print = false;
        self.$data.invoice = JSON.parse('{"id":0,"status":"Active","type":407,"finyear":2023,"series":404,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","buyer_id":0,"saleorder_id":0,"buyer":{"id":0,"type":0,"name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","lr_no":"","lr_date":"0001-01-01","vehicle_no":"","remarks":"","gross_amt":0,"disc_amt":0,"taxable_amt":0,"igst_amt":0,"cgst_amt":0,"sgst_amt":0,"tds_amt":0,"round_off":0,"packingcharges":0,"net_amt":0,"irn":"","ack_no":"","ack_date":"0001-01-01","currency":"INR","conv_rate":1,"list":[]}');


        fetch(`${process.env.VUE_APP_ROOT_API}api/sale/print/${id}?export_info=false&currency=INR`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok) {
            if (!_.isNull(resp.data)) {

              self.$data.filename = 'invoice_4_1.mrt';
              self.$data.invoice = resp;
              self.$data.invoice.data.doc_date = moment(resp.data.doc_date).format('YYYY-MM-DD');
              self.$data.invoice.data.ref_date = moment(resp.data.ref_date).format('YYYY-MM-DD');
              self.$data.reppath =  `${process.env.VUE_APP_ROOT_API}api/sale/${id}`;
              self.$data.can_print = true;

              $('#fsPrintPreview').modal('show');
              // setTimeout(function (){
              //   $('#fsPrintPreview').modal('hide');
              // }, 1000);

            }
          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' })
          }

        }).catch(function (err) {
          swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
        }).finally(()=>{
          self.$data.mytable.bootstrapTable('hideLoading');
        });
      },
      showLRWindow(id){
        const self = this;
        //self.lr_date = moment(self.lr_date).format('YYYY-MM-DD');
        self.lr_date = moment().format('YYYY-MM-DD');
        this.$modal.show('lr_window');
      },
      showExportWindow(id){
        this.invoice_id = id;
        this.getExportInfo();
        this.$modal.show('export_window');
      },
      update_lr_no(){
        const self = this;
        try{
          if( self.lr_no.trim().length == 0){
            alert('Invalid Lr No');
            return;
          }else if( self.lr_date.trim().length == 0){
            alert('Invalid Lr Date');
            return;
          }

          let id = self.$data.invoice_id;

          const requestOptions = {
            method: 'PUT',
            mode: 'cors',
            headers: userService.authHeader(),
            body: `{"id": ${id},"lr_no":"${self.lr_no}","lr_date":"${self.$data.lr_date}"}`
          }

          block_el('#mycard');

          fetch(`${process.env.VUE_APP_ROOT_API}api/saleinvoice_lr`, requestOptions).then(userService.handleResponse).then(function (resp) {
            if (resp.ok) {
              swal({ title: 'Great', type: 'success', text: resp.msg });
              self.$modal.hide('lr_window');
              self.$emit('invoice_lr_saved');
              $('#mycard').unblock();
            } else {
              $('#btnSave').prop('disabled', false);
              $('#mycard').unblock();
              swal({ title: "Oops", text: resp.msg, type: "error" });
            }
          }).catch(function (err) {
            $('#mycard').unblock();
            $('#btnSave').prop('disabled', false);
            swal({ title: "Oops", text: err.toString(), type: "error" });
          });

        }catch (e) {
          alert(e);
        }
      },
      update_export_info(){
        const self = this;
        try{
          self.export_info.id = parseInt(self.$data.invoice_id);

          if( self.export_info.id == 0){
            alert('Invalid Invoice');
            return;
          }



          let id = self.$data.invoice_id;

          const requestOptions = {
            method: 'PUT',
            mode: 'cors',
            headers: userService.authHeader(),
            body: JSON.stringify(self.$data.export_info)
          }

          console.log(JSON.stringify(self.$data.export_info));

          block_el('#mycard');

          fetch(`${process.env.VUE_APP_ROOT_API}api/saleinvoice_export_info`, requestOptions).then(userService.handleResponse).then(function (resp) {
            if (resp.ok) {
              swal({ title: 'Great', type: 'success', text: resp.msg });
              self.$modal.hide('export_window');
              self.$emit('invoice_export_info_saved');
              $('#mycard').unblock();
            } else {
              $('#btnSave').prop('disabled', false);
              $('#mycard').unblock();
              swal({ title: "Oops", text: resp.msg, type: "error" });
            }
          }).catch(function (err) {
            $('#mycard').unblock();
            $('#btnSave').prop('disabled', false);
            swal({ title: "Oops", text: err.toString(), type: "error" });
          });

        }catch (e) {
          alert(e);
        }
      },
      change_unit(id){
        const self = this;

        swal({
          title: "Are you sure?",
          text: "Do you want to proceed with this action?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true
        }).then((result) => {
          if(result.value){

            const requestOptions = {
              method: 'PUT',
              mode: 'cors',
              headers: userService.authHeader()
            }

            self.$data.mytable.bootstrapTable('showLoading');
            fetch(`${process.env.VUE_APP_ROOT_API}api/sale/changeunit/${id}`, requestOptions).then(userService.handleResponse).then((resp) => {
              if (resp.ok) {

                swal({ title: 'Great', type: 'success', text: resp.msg });

              } else {
                swal({ title: 'Oops', text: resp.msg, type: 'error' })
              }

            }).catch(function (err) {
              swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
            }).finally(()=>{
              self.$data.mytable.bootstrapTable('hideLoading');
            });

          }
        });
      },
      generate_irn(id){
        const self = this;

        swal({
          title: "Are you sure?",
          text: "Do you want to proceed with this action?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true
        }).then((result) => {
          if(result.value){

            const requestOptions = {
              method: 'GET',
              mode: 'cors',
              headers: userService.authHeader()
            }

            self.$data.mytable.bootstrapTable('showLoading');
            self.$data.can_print = false;

            fetch(`${process.env.VUE_APP_ROOT_API}api/einvoice/irn_generation/${id}`, requestOptions).then(userService.handleResponse).then(function (resp) {
              if (resp.ok) {

                swal({ title: 'Great', type: 'success', text: resp.msg });

              } else {
                swal({ title: 'Oops', text: resp.msg, type: 'error' })
              }

            }).catch(function (err) {
              swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
            }).finally(()=>{
              self.$data.mytable.bootstrapTable('hideLoading');
            });

          }
        });


      },
    }

  }
</script>

<style scoped>

  .modal-content {
    padding: 0px;
  }
  input:focus {
    background: #feff00;
  }

  textarea:focus {
    background: #feff00;
  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }
</style>
